import { Button } from '@repo/ui/components/button';
import { createFileRoute, Link } from '@tanstack/react-router';
import { Mail } from 'lucide-react';

import { ExperienceBadge } from '@/components/experience-badge';
import { LogoText } from '@/components/logo-text';

export const Route = createFileRoute('/registration/success')({
  component: PreRegistrationSuccessPage,
});

function PreRegistrationSuccessPage() {
  return (
    <div className="mx-auto w-full max-w-md space-y-8 px-4 py-16">
      <div className="text-center">
        <Link to="/" className="inline-block">
          <LogoText className="text-4xl" />
        </Link>
      </div>

      <div className="space-y-6 text-center">
        <div className="bg-primary/10 mx-auto flex h-20 w-20 items-center justify-center rounded-full">
          <Mail className="text-primary h-10 w-10" />
        </div>

        <div className="space-y-2">
          <h1 className="text-2xl font-semibold tracking-tight">
            Verifique seu email
          </h1>
          <p className="text-muted-foreground">
            Enviamos um link mágico para seu e-mail. Clique nele para acessar
            sua conta.
          </p>
        </div>

        <div className="bg-muted/50 text-muted-foreground rounded-lg p-4 text-sm">
          <p>
            Não recebeu o e-mail? Verifique sua pasta de spam ou solicite um
            novo link.
          </p>
        </div>
      </div>

      <div className="flex flex-col space-y-2 text-center">
        <Button asChild variant="outline" className="w-full">
          <Link to="/">Voltar para a página inicial</Link>
        </Button>
        <ExperienceBadge />
      </div>
    </div>
  );
}
